import styled from 'styled-components';

import { useTranslation } from '@hooks';
import { NewButton } from '@components/ui';
import { Text2 } from '@components/styles/Typography';

const PaginationState = ({
    loading,
    hasNextProducts,
    loadRef,
    totalProducts,
    fetchNextPage,
}) => {
    const { t } = useTranslation();
    return (
        <Wrapper ref={loadRef}>
            {!hasNextProducts && !loading ? (
                <NoProduct>
                    <Text2>{`${totalProducts} ${t('noMoreProduct')}`}</Text2>
                </NoProduct>
            ) : (
                <NewButton
                    content={loading ? 'Loading...' : t('loadMore')}
                    onClick={fetchNextPage}
                    data-testid="load-more-button"
                    type="primary"
                    size="large"
                />
            )}
        </Wrapper>
    );
};
const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    width: 100%;
    padding: 100px 0;
    background-color: ${({ theme }) => theme.colors.secondary};
`;
const NoProduct = styled.div`
    div {
        height: 3px;
    }
`;
export default PaginationState;
